module.exports = __webpack_public_path__ + "img/89ne.3885cb22.svg";